import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PackageMiniEntity } from '../../domain/entities/PackageMiniEntity'
import type { PackageAdminListedDtoAdmin } from '@/backend/market'

export class PackageMiniModel extends PackageMiniEntity {
  constructor(dataDto: PackageAdminListedDtoAdmin) {
    super()
    mapEntityProperties<PackageMiniEntity>(this, dataDto, {
      map: {
        vehicleTemplateType: dataDto.vehicleTemplateType
      }
    })
  }
}
